import { Cat, Star, Sun, Paintbrush, Palette, Rocket } from "lucide-react";

const team = [
  {
    name: "Natania",
    bg: "bg-[#FF6B9E]",
    shadow: "shadow-pop-yellow",
    rot: "-rotate-2",
    icon: Rocket,
  },
  {
    name: "Grace",
    bg: "bg-[#FFD166]",
    shadow: "shadow-pop-pink",
    rot: "rotate-3",
    icon: Star,
  },
  {
    name: "Alena",
    bg: "bg-[#38E5B6]",
    shadow: "shadow-pop-blue",
    rot: "-rotate-1",
    icon: Palette,
  },
  {
    name: "Neytra",
    bg: "bg-[#4DB8FF]",
    shadow: "shadow-pop-coral",
    rot: "rotate-2",
    icon: Sun,
  },
  {
    name: "Sadie",
    role: "Designer",
    bg: "bg-[#FF8E72]",
    shadow: "shadow-pop-mint",
    rot: "-rotate-3",
    icon: Paintbrush,
  },
  {
    name: "Elena",
    bg: "bg-[#FFEBF2]",
    shadow: "shadow-pop",
    rot: "rotate-1",
    icon: Cat,
  },
];

export default function Team() {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative py-24 px-4 bg-[#FFEBF2]"
    >
      <div className="text-center mb-16">
        <span className="font-hand text-3xl text-[#4DB8FF]">~ meet the crew ~</span>
        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl text-gray-900 mt-2">
          The <span className="text-[#FF6B9E]">Six</span> of Us!
        </h2>
        <p className="mt-4 text-lg text-gray-700 font-semibold max-w-2xl mx-auto">
          Pinned to the fridge of cool — here we are 📌
        </p>
      </div>

      <div
        data-testid="team-grid"
        className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10"
      >
        {team.map((m) => {
          const Icon = m.icon;
          return (
            <div
              key={m.name}
              data-testid={`team-card-${m.name.toLowerCase()}`}
              className={`relative bg-white border-4 border-gray-900 rounded-3xl p-6 ${m.shadow} ${m.rot} hover:rotate-0 hover:-translate-y-1 transition-transform duration-300`}
            >
              {/* Tape strip */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-24 h-6 bg-[#FFD166]/80 border border-gray-900/20 rotate-[-4deg]"></div>

              {/* Avatar */}
              <div
                className={`mx-auto w-28 h-28 ${m.bg} border-4 border-gray-900 rounded-full flex items-center justify-center mb-4 shadow-pop-sm`}
              >
                <Icon size={48} className="text-gray-900" strokeWidth={2.5} />
              </div>

              <h3 className="font-display text-3xl text-center text-gray-900">
                {m.name}
              </h3>

              {m.role && (
                <div className="flex flex-col items-center gap-1.5 mt-2">
                  <span className="bg-[#FFD166] border-2 border-gray-900 rounded-full px-3 py-1 text-xs font-bold text-gray-900 -rotate-1">
                    ✏️ Designer · Not a sitter
                  </span>
                  <span className="font-hand text-lg text-gray-700 leading-tight">
                    Helps run the club!
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
